module.exports = __webpack_public_path__ + "img/crossRedBallone.0328002d.png";